import React from 'react'

interface IconProps {
  className?: string
}

export const ProductIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M8 3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157 16 3.5C16 4.32843 15.3284 5 14.5 5H9.5C8.67157 5 8 4.32843 8 3.5Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M6 12.1407C6 10.8033 6.6684 9.5544 7.7812 8.81253L8.1094 8.59373C8.6658 8.2228 9 7.59834 9 6.92963V5H15V6.92963C15 7.59834 15.3342 8.2228 15.8906 8.59373L16.2188 8.81253C17.3316 9.5544 18 10.8033 18 12.1407V18C18 20.2091 16.2091 22 14 22H10C7.79086 22 6 20.2091 6 18V12.1407Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <circle 
        cx="12" 
        cy="15" 
        r="3" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
    </svg>
  )
}